import { render, staticRenderFns } from "./DetalleFlujoDigital.vue?vue&type=template&id=2d2b924a&scoped=true"
import script from "./DetalleFlujoDigital.vue?vue&type=script&lang=js"
export * from "./DetalleFlujoDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b924a",
  null
  
)

export default component.exports